import {useEffect, useState} from "react";
import Header from "./Header";
import Loading from "./Loading";
import DonutProgress from "./DonutProgress";
import ComparisonSparkline from "./ComparisonSparkline";
import {fetchImpactScore} from "../service/ManuscriptService";
import {useNavigate} from "react-router-dom";

function ImpactVsField() {
    const navigate = useNavigate();
    const params = new URLSearchParams(window.location.search);
    const id = params.get("id");
    const [loading, setLoading] = useState(true);
    const [likelihood, setLikelihood] = useState(0);
    const [error, setError] = useState(false);

    useEffect(() => {
        setLoading(true);
        setError(false);
        fetchImpactScore(id, true)
            .then(response => {
                if (response) {
                    const impactScore = response.impactScore;
                    if (impactScore != null) {
                        setLikelihood(impactScore);
                    } else {
                        setError(true)
                    }
                }
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            });
    }, [])

    // example data (same length arrays)
    const yourTrend = [10, 14, 22, 20, 28, 35, 42];
    const fieldTrend = [8, 10, 12, 15, 18, 19, 21];

    return (
        <div>
            <Header page="impact-vs-field"/>
            {error ?
                <div className={"submission-error"}>
                    <div>An error occurred while trying to load this submission.</div>
                    <div>Click <a href={"/submissions"}>here</a> to go back to the submissions page.</div>
                </div>
                :
                loading ?
                    <Loading/>
                    :
                    <div className="body">
                        <div className="heading">Impact vs. Field</div>
                        <div className={"dashboard-row"}>
                            <div className={"export-score-text"}>Likelihood of your research influencing future studies
                            </div>
                            <div style={{marginTop: "1rem"}}>
                                <DonutProgress value={likelihood} size={100} strokeWidth={12}/>
                            </div>
                        </div>
                        {/*<div className={"dashboard-row max-width-400"} style={{textAlign: 'left'}}>*/}
                        {/*    <div className={"sub-heading"}>Contributing Factors:</div>*/}
                        {/*    <ul className={"export-score-text"}>*/}
                        {/*        <li>High Relevance</li>*/}
                        {/*        <li>Interdisciplinary Appeal</li>*/}
                        {/*        <li>Clear Research Gap Addressed</li>*/}
                        {/*    </ul>*/}
                        {/*</div>*/}
                        {/*<div className={"max-width-400"} style={{ margin: 'auto' }}>*/}
                        {/*    <ComparisonSparkline*/}
                        {/*        primary={yourTrend}*/}
                        {/*        secondary={fieldTrend}*/}
                        {/*        width={'100%'}*/}
                        {/*        height={160}*/}
                        {/*        strokeWidth={5}*/}
                        {/*    />*/}
                        {/*</div>*/}
                        {/*<div className={"export-score-text"}>Predicted impact vs. the field</div>*/}
                        <button onClick={() => navigate("/submission?id=" + id)} className={"submit fade-in margin-top-1rem"}
                        >Submission</button>
                    </div>
            }
        </div>
    );
}

export default ImpactVsField;
